import { TrashIcon } from "@heroicons/react/24/outline";
import { IconError } from "assets/img/icons";
import { PLACEHOLDER_IN_BASE64 } from "constants/common";
import THEME from "constants/themes";
import { isEmpty } from "lodash";
import { SelectedFileTypes } from "models/Widget";
import {
	StyledIcon,
	StyledImg,
	StyledText,
	StyledWrapper,
} from "styled-components/Common/CommonStyled";
import { StyledTooltip } from "styled-components/WidgetBuilder/UploadProgressStyled";

type SelectedFileListProps = {
	fileList: SelectedFileTypes[];
	onRemoveFile: (positionIndex: number) => void;
};

const SelectedFileList = (props: SelectedFileListProps) => {
	const { fileList, onRemoveFile } = props;

	const renderFileItem = (item: SelectedFileTypes, index: number) => {
		const { file } = item || {};

		return (
			<StyledWrapper
				background={
					item?.error && !isEmpty(item?.error)
						? "rgba(247, 99, 99, 0.2)"
						: "rgba(224, 227, 229, 0.20)"
				}
				padding="8px 16px"
				display="flex"
				justifyContent="space-between"
				alignItem="center"
				margin={index === fileList.length - 1 ? "0" : "0 0 12px 0"}
				borderRadius="12px">
				<StyledWrapper maxWidth="calc(100% - 60px)" display="flex" alignItems="center" gap="8px">
					{item?.thumbnail && (
						<StyledWrapper
							minWidth="32px"
							width="32px"
							height="32px"
							borderRadius="8px"
							overflow="hidden">
							<StyledImg
								src={item?.thumbnail || item?.cover_image_url || PLACEHOLDER_IN_BASE64.IMAGE}
								width={"100%"}
								height={"100%"}
								preview={false}
								objectFit="cover"
								fallback={PLACEHOLDER_IN_BASE64.IMAGE}
							/>
						</StyledWrapper>
					)}
					<StyledText>{file?.name || item?.name || item?.title}</StyledText>
				</StyledWrapper>

				<StyledWrapper display="flex" alignItems="center" gap="8px">
					{item?.error?.msg && (
						<StyledTooltip
							overlayClassName="upload-status-error-tooltip"
							title={
								<StyledWrapper
									dangerouslySetInnerHTML={{
										__html: item?.error?.msg,
									}}
								/>
							}
							trigger={["hover", "focus"]}>
							<StyledIcon cursor="pointer" colorPath={THEME.colors.redBase} size={16}>
								<IconError />
							</StyledIcon>
						</StyledTooltip>
					)}
					<StyledIcon cursor="pointer" size={20} onClick={() => onRemoveFile(index)}>
						<TrashIcon />
					</StyledIcon>
				</StyledWrapper>
			</StyledWrapper>
		);
	};

	return fileList.length ? (
		<StyledWrapper>
			{fileList.map((item, index) => {
				return renderFileItem(item, index);
			})}
		</StyledWrapper>
	) : (
		<></>
	);
};

export default SelectedFileList;
